import { App } from '@capacitor/app';
import classnames from 'classnames';
import * as React from 'react';

import { useApplication, useUserdata } from '../AppContext';

export const PageTitle = React.memo(({ children, className, shouldShowVolume = false, returnPage = undefined }) => {

	const app = useApplication();
	const userdata = useUserdata();

	const handleVolumeClick = React.useCallback((e) => {
		e?.stopPropagation?.();
		e?.preventDefault?.();

		app.setIsMuted(!userdata?.isMuted);
	}, [app, userdata?.isMuted]);

	const handleBackClick = React.useCallback((e) => {
		e?.stopPropagation?.();
		e?.preventDefault?.();
		app.multiplayer?.leaveGameRooms?.();
		app.navigate(returnPage ?? '#');
	}, [app, returnPage]);

	React.useEffect(() => {
		const listener = () => {
			handleBackClick();
		};

		let removeHandler;

		App.addListener('backButton', listener).then((handle) => {
			removeHandler = handle.remove;
		});

		return () => {
			if (typeof removeHandler === 'function') {
				removeHandler();
			} else {
				App.removeAllListeners();
			}
		};
	}, [handleBackClick]);

	const volumeControl = React.useMemo(() => {
		if (!shouldShowVolume) {
			return null;
		}

		return (
			<a
				className={classnames('volumeButton', 'ui-icon', userdata?.isMuted ? 'ui-volume-off' : 'ui-volume-on')}
				href="#/"
				onClick={handleVolumeClick}
				id="menu-volume-button">
			</a>
		);
	}, [shouldShowVolume, userdata?.isMuted, handleVolumeClick]);

	return (
		<div className={classnames('pageTitle', 'flex-0-1-auto', className)}>
			<a className="ui-icon ui-back backButton" href="#" onClick={handleBackClick}></a>
			{volumeControl}
			{children}
		</div>
	);
});

PageTitle.displayName = 'PageTitle';
